import $ from 'jquery';
import axios from "axios";

function searchRegions(form) {
    let val = form.children('#postcode').val();
    let data = form.serialize();
    let results = $('#region-search-results');

    if(val.length > 1) {
        $.ajax({
            url: '/search-regions',
            type: 'GET',
            cache: false,
            data: data,
            success: function (response) {
                results.html(response);
                results.addClass('show');
            }
        });
    }
}

$(function() {
    $(document).on('click', function (e) {
        e.stopPropagation();
        $('#region-search-results').removeClass('show');
    });

    $(document).on('input', '#postcode', function() {
        searchRegions($(this).parent());
    });

    $(document).on('click', '#postcode', function() {
        searchRegions($(this).parent());
    });

    $(document).on('click', '.bdm-lookup .results button', 'click', function() {
        let form = $(this).parent().parent().parent().parent();
        let search = $('#postcode');
        let val = $(this).text();

        search.val(val);
        form.submit();
    });
});
